<template>

  <v-row justify="center" align="center">
    <v-flex xs12 xl10 class="mt-3">
      <v-scale-transition>
        <v-layout wrap align-center justify-center v-show="done">

          <v-flex xs12 text-center>
            <h1 class=" my-2 subtitle font-weight-light">¡Cita Agendada!</h1>
          </v-flex>

          <v-flex xs12 md8 lg6 class="my-3" v-if="postScheduleMessage">
            <v-alert
                border="left"
                type="accent"
                icon="info"
                prominent
                :value="true"
                >
              <div v-html="postScheduleMessage"/>
            </v-alert>
          </v-flex>

          <v-flex v-else xs12 class="text-center">
            <v-sheet height="220" color="transparent">
              <small>Hemos enviado un correo al {{clientSingular | lowercase}}</small>
              <div class="pa-3">
                <v-avatar size="120" color="success">
                  <v-icon size="70" color="white">fas fa-clipboard-check</v-icon>
                </v-avatar>
              </div>
            </v-sheet>
          </v-flex>

          <v-flex xs12 class="text-center">
            <v-btn rounded color="primary" @click="finishInternal">Continuar</v-btn>
          </v-flex>
        </v-layout>
      </v-scale-transition>
    </v-flex>

    <v-flex xs12 xl10 v-if="!done">
      <v-stepper non-linear v-model="step" class="p-0" id="stepper">
        <v-stepper-header class="secondary-card lighten-1">

          <v-stepper-step :color="step > 1 ? 'green' : 'primary'" :complete="step > 1" step="1">
            Selecciona un especialista
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :color="step > 2 ? 'green' : 'primary'" :complete="step > 2" step="2">
            Selecciona la hora
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step color="primary" step="3">
            Selecciona paciente
          </v-stepper-step>

        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-flex xs12 sm10 md8 xl6 :class="['step-content-wrapper', 'step-1-m', {'fullscreen': isFullScreen}]">

              <treatment-search
                  ref="treatmentSearch"
                  :default-appointment="defaultAppointment"
                  :allow-modifying="allowModifying"
                  :provider="provider"
                  :branch-office="branchOffice"
                  :internal="internal"
                  :onClear="onScheduleClear"
                  :autoFocus="false"
                  :individual-provider="individualProvider !== undefined ? individualProvider : false"
                  v-on:change="onScheduleSelect"
                  showCard="true"></treatment-search>

              <v-divider class="my-1"></v-divider>

              <v-sheet color="transparent" height="15">
                <v-scroll-y-transition>
                  <small v-show="defaultEventIsLocked" class="primary--text ml-4">Alguien esta reservando esta
                    hora</small>
                </v-scroll-y-transition>
              </v-sheet>


              <v-scroll-y-transition>
                <div class="mt-1"
                     v-show="schedule && typeof schedule === 'object' && (!defaultAppointment|| (defaultAppointment && allowModifying))">
                  <template v-if="nextAvailableEvent">
                    <v-btn :disabled="defaultEventIsLocked" @click="setDefaultEvent" color="primary" small >
                      <v-icon class="mr-1" size="16">mdi-check</v-icon>
                      Seleccionar
                    </v-btn>
                    <v-btn class="ml-1" color="secondary" small @click="next" outlined>
                      <v-icon class="mr-1" size="16">fas fa-mouse-pointer</v-icon>
                      Ver más
                    </v-btn>
                  </template>

                </div>

              </v-scroll-y-transition>

              <v-alert :value="appointmentTimeout" type="info" color="error" class="kim-card mt-3">
                Solo puedes mantener un bloque seleccionado durante 10 min., dado que esta acción impide a otros
                seleccionar el mismo bloque.
              </v-alert>

            </v-flex>
          </v-stepper-content>

          <v-stepper-content step="2">

            <v-flex sm12 md10 lg9 xl8 :class="['step-content-wrapper', 'step-1-m', {'fullscreen': isFullScreen}]"
                    style="margin: auto">
              <appointment-events
                  :internal="isInternal"
                  :height="isFullScreen ? '50vh' : height"
                  v-on:select="onEventSelect"
                  v-on:event-created="onEventCreated"
                  :schedule="schedule"
                  :defaultAppointment="defaultAppointment"
                  :selected="selectedEvent"
                  :locked-events="lockedEvents"/>
            </v-flex>

            <v-flex xs12 text-right class="actions-wrapper" v-if="!hideNavControls">
              <v-btn flat @click="back">Atrás</v-btn>
              <v-btn
                  color="primary" depressed :disabled="!step3Enabled"
                  @click="next">Siguiente
              </v-btn>
            </v-flex>

          </v-stepper-content>

          <v-stepper-content step="3" class="pr-1 pl-1">

            <v-col cols="12" :class="['step-content-wrapper pa-2', 'step-1-m']"
                   >

                <v-row >
                  <v-col cols="12" md="5" lg="4" xl="3">
                    <appointment-summary
                        v-if="selectedEvent"
                        :internal="isInternal"
                        :vc-allowed="allowsVC"
                        :individual-provider="individualProvider"
                        :event="selectedEvent"
                        :schedule="schedule"
                        :default-free="(defaultAppointment && defaultAppointment.payment && defaultAppointment.payment.type === 'free') || false"
                        :default-vc="!!(defaultAppointment && defaultAppointment.vc_id)"
                        :default-labels="(defaultAppointment && defaultAppointment.labels) || []"
                        @change:labels="labels = $event"
                        @change:free="free = $event"
                        @change:vc="isVideoCall = $event"
                        @click:edit:specialist="step = 1"
                        @click:edit:date="step = 2"
                    />

                  </v-col>

                  <v-col cols="12" md="6" lg="5" xl="5">
                    <component
                        ref="additionalConfig"
                        :internal="internal"
                        :requiredFields="requiredFields"
                        :requestedFields="requestedFields"
                        :default-client="clientToPreload"
                        :default-companions="companionsToPreload"
                        @valid="configValid = $event"
                        :is="configComponent"
                        :provider-id="provider"
                        @change="config = $event"
                    />
                  </v-col>
                </v-row>
            </v-col>

            <v-flex xs12 text-right class="actions-wrapper" v-if="!hideNavControls">
              <v-btn flat @click="back">Atrás</v-btn>
              <v-btn
                  color="primary"
                  :loading="loadingSave"
                  class="mr-0"
                  @click="next"
                  :disabled="!finishEnabled"
                  :dark="finishEnabled"
              >
                Agendar
              </v-btn>
            </v-flex>

          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-flex>
  </v-row>

</template>

<script>

import {mapState, mapMutations} from 'vuex'
import TreatmentSearch from '@/components/appointments/TreatmentSearch'
import DayPicker from '@/components/appointments/DayPicker'
import HourPicker from '@/components/appointments/HourPicker'
import ContinueButton from '@/components/common/ContinueButton'
import NextDatePicker from '@/components/specialists/NextDatePicker'
import ClientPicker from '@/components/appointments/steps/ClientPicker'
import ClientCardItem from '@/components/appointments/steps/ClientCardItem'
import AppointmentSummary from '@/components/appointments/steps/AppointmentSummary'
import AppointmentSettings from '@/components/appointments/steps/AppointmentSettings'

import AppointmentEvents from './AppointmentEvents.vue'
import PsychologistAppointmentConfig from './config/psychologist/PsychologistAppointmentConfig.vue'
import StandardAppointmentConfig from './config/StandardAppointmentConfig.vue'

import {appointmentConfigComponent} from '../../utils/Specialist'

import {rutValidator, rutFormat} from '@/utils/Common'
import {ApiUtils} from '@/utils/ApiUtils'
import {whisperOnPrivate, listenPrivateWhisper, leaveChannel} from '@/utils/Sockets'
import {uuid} from "../../utils/Common";
import AppointmentsMixin from "@/mixins/AppointmentsMixin";

export default {
  props: [
    'provider',
    'internal',
    'fullscreen',
    'height',
    'defaultAppointment',
    'allowModifying',
    'individualProvider',
    'branchOffice',
    'hideNavControls',
    'redirectUrl',
    'postScheduleMessage',
  ],
  components: {
    TreatmentSearch,
    ContinueButton,
    DayPicker,
    HourPicker,
    NextDatePicker,
    AppointmentEvents,
    PsychologistAppointmentConfig,
    StandardAppointmentConfig,
    ClientPicker,
    ClientCardItem,
    AppointmentSummary,
    AppointmentSettings
  },
  mixins: [AppointmentsMixin],
  created() {
    var vm = this
    document.addEventListener('beforeunload', vm.stopSockets)
  },
  beforeDestroy() {
    var vm = this
    vm.stopSockets()
  },
  mounted() {

    var vm = this
    vm.done = false
    vm.schedule = null
    vm.selectedEvent = null
    vm.selectedPatient = null

    if (vm.isInternal) {
      vm.showDNISearch = true
      vm.patientTarget = 'other'
      return
    }

    if (this.currentUser) {
      this.currentUserId = this.currentUser.id
      this.forMe()
    } else {
      this.currentUserId = uuid()
    }

  },
  data() {
    return {
      labels: null,
      appointmentIdToModify: null,
      clientToPreload: null,
      companionsToPreload: null,
      currentUserId: null,
      config: null,
      configValid: false,
      isVideoCall: false,
      appointmentTimeout: false,
      freeLockTimeout: null,
      free: false,
      showDNISearch: true,
      foundDNIUser: null,
      loadingDNISearch: false,
      loadingSave: false,
      showPatientSignUp: false,
      schedule: null,
      lockedEvents: [],
      locking: {},
      lockingOthers: null,
      rutRules: [
        rutValidator
      ],
      dni: '',
      patientTarget: 'other', // options: me | other
      selectedEvent: null,
      availableIntervals: [],
      specialist: null,
      selectedPatient: null,
      step: 1,
      step2Enabled: false,
      step3Enabled: false,
      step4Enabled: false,
      done: false
    }
  },
  watch: {
    defaultAppointment(val){
      const vm = this
      if(val && val.id && vm.allowModifying){
        vm.appointmentIdToModify = val.id

        if(val.client){
          vm.clientToPreload = val.client
        }

        if(val.companions && val.companions.length > 0){
          vm.companionsToPreload = val.companions
        }

      }else{
        vm.appointmentIdToModify = null
        vm.clientToPreload = null
        vm.companionsToPreload = null
      }
    },
    navControls(val){
      const vm = this
      vm.$emit('change:controls', val)
    },
    appointmentTimeout(val) {
      var vm = this
      if (val) {
        vm.selectedEvent = null
        vm.step = 1
      }
    },
    currentUser(val) {

      var vm = this

      if (vm.isInternal) {
        vm.showDNISearch = true
        vm.patientTarget = 'other'
        return
      }

      if (!val) {
        vm.showDNISearch = true
        vm.patientTarget = ''
        vm.currentUserId = uuid()
        if (vm.foundDNIUser) {
          vm.selectedPatient = {
            id: vm.foundDNIUser.id,
            firstName: vm.foundDNIUser.first_name,
            lastName: vm.foundDNIUser.last_name || '',
            email: vm.foundDNIUser.email || '',
            phone1: vm.foundDNIUser.phone1 || '',
            phone2: vm.foundDNIUser.phone2 || '',
          }
          return
        }

        vm.dni = ''
        vm.selectedPatient = null
        return
      }

      vm.currentUserId = val.id

      if (vm.patientTarget === 'other') {
        vm.showDNISearch = true
        if (vm.foundDNIUser) {
          vm.selectedPatient = {
            id: vm.foundDNIUser.id,
            firstName: vm.foundDNIUser.first_name,
            lastName: vm.foundDNIUser.last_name || '',
            email: vm.foundDNIUser.email || '',
            phone1: vm.foundDNIUser.phone1 || '',
            phone2: vm.foundDNIUser.phone2 || '',
          }
          return
        }

        vm.dni = ''
        vm.selectedPatient = null
        return
      }

      vm.showDNISearch = false
      vm.patientTarget = 'me'
      vm.selectedPatient = {
        id: vm.currentUser.id,
        firstName: vm.currentUser.first_name,
        lastName: vm.currentUser.last_name || '',
        email: vm.currentUser.email || '',
        phone1: vm.currentUser.phone1 || '',
        phone2: vm.currentUser.phone2 || '',
      }

    },
    dni(val) {
      this.dni = rutFormat(val)
    },
    patientTarget(val) {
      if (val == '' || val == 'other') {
        this.showDNISearch = true
      } else {
        this.showDNISearch = false
      }
    },
    selectedEvent(newVal) {
      var vm = this
      vm.stopLockingOthers()
      vm.$nextTick(function () {
        if (newVal) {

          clearTimeout(vm.freeLockTimeout)
          vm.freeLockTimeout = null

          whisperOnPrivate(`schedule.${vm.schedule.id}`, 'lockEvent', {
            by: vm.currentUserId,
            event: newVal
          })

          vm.lockingOthers = setInterval(function () {
            whisperOnPrivate(`schedule.${vm.schedule.id}`, 'lockEvent', {
              by: vm.currentUserId,
              event: newVal
            })
          }, 5000)

          vm.freeLockTimeout = setTimeout(function () {
            vm.stopLockingOthers()
            vm.appointmentTimeout = true
          }, (10 * 1000 * 60)) // 10 mins. todo: move this prop to settings

          this.step3Enabled = true
        } else {
          this.step3Enabled = false
        }
      })
    },
    schedule(newVal, oldVal) {
      var vm = this
      vm.lockedEvents = []

      if (newVal) {
        listenPrivateWhisper(`schedule.${newVal.id}`, 'lockEvent', vm.whileLocked)
      }

      if (oldVal) {
        leaveChannel(`schedule.${oldVal.id}`)
      }

    },
    step(val) {
      var vm = this

      if (val === 1) {
        vm.stopLockingOthers()
        vm.selectedEvent = null
      }

      if (val === 2) {
        vm.appointmentTimeout = false
      }

      if (val === 3) {
        vm.appointmentTimeout = false
      }

    }
  },
  computed: {
    ...mapState(['currentUser']),
    navControls(){
      const vm = this

      if(vm.done){
        return {
          back: {
            show: false,
            disabled: true,
            label: 'Atrás'
          },
          next: {
            show: false,
            disabled: true,
            label: 'Siguiente'
          }
        }
      }

      if (vm.step === 1) {
        return {
          back: {
            show: false,
            disabled: false,
            label: 'Atrás'
          },
          next: {
            show: false,
            disabled: false,
            label: 'Siguiente'
          }
        }
      }

      if (vm.step === 2) {
        return {
          back: {
            show: true,
            disabled: false,
            label: 'Atrás'
          },
          next: {
            show: true,
            disabled: !vm.step3Enabled,
            label: 'Siguiente'
          }
        }
      }

      if (vm.step === 3) {
        return {
          back: {
            show: true,
            disabled: false,
            label: 'Atrás'
          },
          next: {
            show: true,
            disabled: !vm.finishEnabled,
            label: 'Agendar',
            loading: vm.loadingSave
          }
        }
      }
    },
    requiredFields() {
      var vm = this
      if (!vm.schedule || !vm.schedule.client_form_fields) return []

      const fields = vm.schedule.client_form_fields
      return fields.filter(field => field.pivot.required)
          .map(field => field.name)

    },
    requestedFields() {
      var vm = this
      if (!vm.schedule || !vm.schedule.client_form_fields) return []
      const fields = vm.schedule.client_form_fields
      return fields.map(field => field.name)
    },
    finishEnabled() {
      var vm = this
      return vm.configValid && !!vm.selectedEvent
    },
    configComponent() {
      var vm = this
      if (!vm.schedule) return ''
      const service = vm.schedule.service_item && vm.schedule.service_item.description || null
      return appointmentConfigComponent(service)
    },
    showVCOptions() {

      var vm = this
      if (vm.isInternal) return true

      return vm.allowsVC

    },
    allowsVC() {
      var vm = this
      return !!vm.schedule && vm.schedule.specialist && vm.schedule.specialist.allows_vc
    },
    nextAvailableEvent() {

      var vm = this
      return vm.schedule && vm.schedule.next_available_event || null

    },
    isInternal() {
      return this.internal !== undefined && this.internal !== false
    },
    backTo() {

    },
    isFullScreen() {
      var vm = this
      return vm.fullscreen !== undefined && vm.fullscreen !== false
    },
    defaultEventIsLocked() {

      var vm = this
      if (!vm.schedule || !vm.schedule.next_available_event) return false
      return vm.lockedEvents.find(event => event === vm.schedule.next_available_event.id) !== undefined

    },
    events() {
      var vm = this
      var events = vm.schedule && vm.schedule.schedule_events && vm.schedule.schedule_events.slice() || []
      return events
    },
    formattedDate() {
      return this.$moment(this.selectedDate).format('ddd') + ', ' +
          this.$moment(this.selectedDate).format('D') + ' ' +
          this.$moment(this.selectedDate).format('MMMM') + ' ' +
          this.$moment(this.selectedDate).format('Y') + ''
    }
  },
  methods: {
    ...mapMutations(['showSnackBar']),
    onAdditionalConfigConfirm(config) {
      this.additionalConfig = config
    },
    onAdditionalConfigCancel() {
      var vm = this
      vm.additionalConfig = null
      vm.step = 2
    },
    loadSchedules() {
      this.$refs.treatmentSearch.getSchedules()
    },
    back() {
      const vm = this
      if (vm.step === 1) return
      vm.goTo(vm.step - 1)
    },
    next() {
      const vm = this
      if (vm.step === 3) return vm.finish()
      vm.goTo(vm.step + 1)
    },
    reset() {
      var vm = this
      vm.labels = null
      vm.appointmentIdToModify = null
      vm.clientToPreload = null
      vm.done = false
      vm.config = null
      vm.schedule = null
      vm.selectedEvent = null
      vm.selectedPatient = null
      vm.isVideoCall = false
      vm.free = false
      vm.step = 1
      vm.dni = ''
      this.step2Enabled = false
      this.step3Enabled = false
      this.step4Enabled = false
      if (this.$refs.treatmentSearch) {
        this.$refs.treatmentSearch.reset()
      }
    },
    finishInternal() {
      var vm = this

      const regex = new RegExp('https?:\\/\\/.+\\.\\w{1,6}[\\/]?.+', 'g')

      if(vm.redirectUrl && regex.test(vm.redirectUrl)){
        window.location.href = vm.redirectUrl
        return
      }

      vm.$emit('close')
      vm.done = false
      vm.schedule = null
      vm.selectedEvent = null
      vm.selectedPatient = null
      vm.dni = ''
      vm.step = 1
    },
    onEventCreated(newEvent) {
      var vm = this
      if (!vm.schedule) return
      var schedule = JSON.parse(JSON.stringify(vm.schedule))
      schedule.schedule_events.push(newEvent)
      vm.schedule = schedule
    },
    setDefaultEvent() {
      var vm = this
      if (!vm.schedule || !vm.nextAvailableEvent) return
      vm.selectedEvent = vm.nextAvailableEvent
      vm.step = 3
    },
    whileLocked(locked) {
      var vm = this
      if (vm.selectedEvent && locked.event.id === vm.selectedEvent.id) return
      vm.setLocking(locked.event.id)
    },
    setLocking(eventId) {
      var vm = this
      var lockedEvents = vm.lockedEvents.slice()
      var foundIndex = lockedEvents.findIndex(event => event === eventId)
      if (foundIndex === -1) lockedEvents.push(eventId)
      vm.lockedEvents = lockedEvents
      clearTimeout(vm.locking[eventId])
      console.log('start locking:', eventId)
      vm.locking[eventId] = setTimeout(function () {
        console.log('stop locking:', eventId)
        var foundIndex = vm.lockedEvents.findIndex(event => event === eventId)
        vm.lockedEvents.splice(foundIndex, 1)
        clearTimeout(vm.locking[eventId])
      }, 6000)
    },
    stopSockets() {
      var vm = this
      if (vm.schedule) leaveChannel(`schedule.${vm.schedule.id}`)
      vm.stopLockingOthers()
    },
    stopLockingOthers() {
      var vm = this
      clearInterval(vm.lockingOthers)
      vm.lockingOthers = null
    },
    onScheduleClear() {
      this.schedule = null
    },
    onDaySelect(date) {
      this.selectedDate = date.date
      this.selectedEvent = date.details && date.details.intervals.length > 0 ? date.details.intervals[0] : null
      this.availableIntervals = date.details ? date.details.intervals : []
      this.step3Enabled = true
    },
    whenNoDaysAvailable() {
      this.step2Enabled = false
      this.step3Enabled = false
      this.step4Enabled = false
    },
    onEventSelect(event) {
      var vm = this
      vm.selectedEvent = event
      vm.$nextTick(function(){
        if (vm.defaultAppointment && !vm.allowModifying) {
          vm.step = 3
        }
      })
    },
    onScheduleSelect(schedule) {
      var vm = this
      vm.step2Enabled = true
      vm.schedule = schedule
    },
    goTo(step = 1) {
      this.step = step
    },
    setNextDateAvailable(date) {
      this.selectedDate = date.date
      this.selectedEvent = date.interval
      this.goTo(4)
    },
    goToStep2() {
      this.goTo(2)
    },
    async getAvailableDates(specialistId = null) {
      if (!specialistId) {

      }
    },
    forMe() {
      var vm = this
      vm.patientTarget = 'me'
      if (vm.currentUser !== null && vm.foundDNIUser) {
        vm.selectedPatient = {
          id: vm.foundDNIUser.id,
          firstName: vm.foundDNIUser.first_name,
          lastName: vm.foundDNIUser.last_name || '',
          email: vm.foundDNIUser.email || '',
          phone1: vm.foundDNIUser.phone1 || '',
          phone2: vm.foundDNIUser.phone2 || '',
        }
      }
    },
    forSomeoneElse() {
      var vm = this
      vm.patientTarget = 'other'
      vm.selectedPatient = vm.foundDNIUser ? {
            id: vm.foundDNIUser.id,
            firstName: vm.foundDNIUser.first_name,
            lastName: vm.foundDNIUser.last_name,
            email: vm.foundDNIUser.email,
            phone1: vm.foundDNIUser.phone1,
            phone2: vm.foundDNIUser.phone2,
          }
          : null
    },
    async searchDNI() {
      var vm = this
      if (rutValidator(vm.dni) !== true) {
        vm.showSnackBar('El RUT ingresado es inválido')
        return
      }

      //if(vm.foundDNIUser && vm.foundDNIUser)

      vm.loadingDNISearch = true
      const url = vm.isInternal ? 'user/dni' : 'public/user/dni'
      const response = await ApiUtils.makeGet(url, {
        dni: vm.dni
      })
      vm.loadingDNISearch = false

      if (response.ok) {
        const json = await response.json()
        let patient = json.result.user
        vm.foundDNIUser = patient
        vm.$nextTick(function () {
          vm.selectedPatient = {
            id: vm.foundDNIUser.id,
            firstName: vm.foundDNIUser.first_name,
            lastName: vm.foundDNIUser.last_name || '',
            email: vm.foundDNIUser.email || '',
            phone1: vm.foundDNIUser.phone1 || '',
            phone2: vm.foundDNIUser.phone2 || '',
          }
        })
        return
      }

      const json = await response.json()
      if (json.code == 404) {
        vm.showSnackBar('RUT no encontrado')
        //todo: open patient signup dialog
        vm.showPatientSignUp = true
        vm.foundDNIUser = null
        vm.selectedPatient = null
        return
      }

    },
    clearDNI(evt) {
      var vm = this
      vm.dni = ''
      vm.foundDNIUser = null
      vm.selectedPatient = null

    },
    onSignUpSuccess(user) {
      var vm = this
      vm.selectedPatient = {
        id: user.id,
        firstName: user.first_name,
        lastName: user.last_name || '',
        email: user.email || '',
        phone1: user.phone1 || '',
        phone2: user.phone2 || '',
      }
      vm.showPatientSignUp = false
      vm.dni = rutFormat(user.dni)
    },
    async finish() {
      var vm = this
      if (vm.loadingSave || !vm.configValid) return

      vm.loadingSave = true
      var payload = {
        type: vm.isVideoCall ? 'video' : 'standard',
        schedule_id: vm.schedule.id,
        time: vm.selectedEvent.time,
        date: vm.selectedEvent.date,
        extra: vm.selectedEvent.extra ? 1 : 0,
        scheduled_from: vm.isInternal ? 'internal' : 'public'
      }

      if (vm.isInternal) {
        payload.free = vm.free ? 1 : 0
        if(vm.labels && vm.labels.length > 0){
          payload.labels = vm.labels.map(lbl => lbl.id)
        }

        if(vm.appointmentIdToModify && vm.allowModifying){
          const cancelReason = `El ${vm.clientSingular.toLowerCase()} cambió la cita para: ${vm.selectedEvent.date} a las ${vm.selectedEvent.time}`
          let cancelSuccess = await vm.cancelAppointment(vm.appointmentIdToModify, cancelReason)
          if(!cancelSuccess){
            //cancel retry
            await vm.cancelAppointment(vm.appointmentIdToModify, cancelReason)
          }
        }

      }

      const response = await ApiUtils.makePost(`public/appointment`, {
        ...vm.config,
        ...payload
      })
      vm.loadingSave = false

      if (!response.ok) {
        const json = await response.json()
        vm.toast(json.message || 'Ha ocurrido un error intentando agendar', 'error')
        return
      }

      const json = await response.json()
      vm.done = true
      vm.$emit('appointment-created', json.result)

    }
  }
}
</script>

<style scoped>

#stepper{
  overflow: visible !important;
}

>>>.fr-emoticon.fr-deletable.fr-emoticon-img{
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: auto;
  display: inline-block;
  width: 25px;
}

>>>.v-stepper__header {
  position: sticky;
  top: 5px;
  z-index: 2;
}

>>>.v-stepper__wrapper{
  overflow: visible;
}

.bordered {
  margin-left: 10px
}

.step-1-m {
  margin-bottom: 74px
}

.step-content-wrapper {

}

.step-content-wrapper.fullscreen {
}

.v-stepper {
  box-shadow: none;
}

.actions-wrapper {
  margin: 25px auto 0 auto;
  border-top: 1px solid rgba(0, 0, 0, .2);
  background-color: #fff;
  z-index: 10;
  position: relative;
}

.sm-title {
  font-weight: 300;
  padding-bottom: 5px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
}

</style>
